var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-layout__content"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"text-center"},[_c('b-img',{attrs:{"src":require('./images/Chest_rates_vertical.png'),"fluid":"","alt":"Fluid image"}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }